import React from 'react';

import { AddOutlined } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useInviteUser } from '../hooks/useInviteUser';

export interface InviteProps {
  onInviteUsers: () => void;
}

export const Invite = ({ onInviteUsers }: InviteProps) => {
  const { t } = useTranslation();
  const { openInviteUserFormDialog } = useInviteUser();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        startIcon={<AddOutlined />}
        sx={{ mt: 2, mb: 2 }}
        onClick={() => {
          openInviteUserFormDialog(onInviteUsers);
        }}
      >
        {t('userManagement.inviteBtn.label', {
          defaultValue: 'Invite users',
        })}
      </Button>
    </Box>
  );
};
